module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "striiv-sleep-graph"
    }
  }, [_c('mu-paper', [(_vm.hasSleepData && !_vm.isLoading) ? _c('striiv-sleep-chart', {
    attrs: {
      "chart-data": _vm.data,
      "options": _vm.options
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading && !_vm.hasSleepData) ? _c('mu-card-text', [_c('alert', {
    attrs: {
      "type": "info",
      "icon": "info"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n          Not enough data to create a chart\n        ")])])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05d65148","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tracking/Graphs/Sleep/StriivSleepGraph.vue
// module id = 3029
// module chunks = 1